import  EmbedChatbot  from './components/EmbedChatbot/index.vue';
const coms = [EmbedChatbot]

const install = (app) => {
  coms.forEach((com) => {
    app.component(com.name, com);
  })
}

if(typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install
};